import useInvalidateShop from "./use-invalidate-shop";
import { useApiMutation } from "./use-api-mutation";

type UpdateShopWorkflowLogisticianVariables = {
  activated: boolean;
  /** BAB-2943. Omit to leave the setting untouched. */
  canValidateAfterMerchantValidation?: boolean;
};

export default function useUpdateShopWorkflowLogistician(shopId: string) {
  const invalidateShop = useInvalidateShop(shopId);

  return useApiMutation(
    "patch",
    "/shops-workflowlogistician/{shopId}/workflowlogistician",
    {
      invalidate: invalidateShop,
      mapVariables: (
        variables: boolean | UpdateShopWorkflowLogisticianVariables,
      ) => ({
        params: { path: { shopId } },
        body:
          typeof variables === "boolean" ? { activated: variables } : variables,
      }),
    },
  );
}
